import React from 'react';
import { Authenticated } from 'react-admin';
import { Redirect, Route } from 'react-router-dom';
import Calendar from './calendar/Calendar';
import ForgotPassword from './components/ForgotPassword';
import PrivacyPolicyPage from './Privacy';
import ResetPassword from './components/ResetPassword';
import Settings from './settings';
import { ProSignup } from './Signup';
import { ProList } from './tabs/pros';
import Zipchat from './zipchat/Zipchat';
import QuoteBuilder from './tabs/quotes/QuoteBuilder';

import PreviewSMS from './mustache/preview-sms';
import MuiCalendar from './MuiCalendar/WrappedCalendar';
import Dispatch from './Dispatch';
import InsightPage from './insights/InsightPage';
import BusinessConfiguration from './tabs/business_configuration/BusinessConfiguration';
import ActivityFeed from './tabs/activity-feed/ActivityFeed';
import GPSTracker from './GPSTracker';
import Integrations from './Integrations';
import StripeCustomersToSquare from './Integrations/StripeCustomersToSquare';
import PaymentDue from './tabs/scheduled_work/PaymentDue';
import SalesTaxReport from './tabs/scheduled_work/SalesTaxReport';
import EditAvailability from './MuiCalendar/EditAvailability/EditAvailability';

import { userIsZippityEmployee } from './helper';

const InternalAuthenticated = ({ children }) => (
  <Authenticated>
    {userIsZippityEmployee() ? children : <Redirect to="/" />}
  </Authenticated>
);

const ZippityPrivateRoutes = [
  <Route
    exact
    path="/pro-signup"
    render={() => (
      <InternalAuthenticated>
        <ProSignup />
      </InternalAuthenticated>
    )}
  />,
  <Route
    exact
    path="/pro-list/create"
    render={() => (
      <InternalAuthenticated>
        <ProSignup />
      </InternalAuthenticated>
    )}
  />,
  <Route
    exact
    path="/pro-list"
    render={(props) => (
      <InternalAuthenticated>
        <ProList {...props} resource="pro" basePath="pro" />
      </InternalAuthenticated>
    )}
  />,
];

export default [
  <Route exact path="/forgot-password" component={ForgotPassword} noLayout />,
  <Route exact path="/privacy-policy" component={PrivacyPolicyPage} noLayout />,
  <Route
    exact
    path="/reset-password/:uuid"
    component={ResetPassword}
    noLayout
  />,
  <Route
    path="/client_location"
    render={() => <Redirect to="/client-location" />}
  />,
  <Route
    path="/service_custom_message"
    render={() => <Redirect to="/service-custom-message" />}
  />,
  <Route
    path="/service_offering"
    render={() => <Redirect to="/service-offering" />}
  />,
  <Route
    path="/service_offering_checklist"
    render={() => <Redirect to="/service-offering-checklist" />}
  />,
  <Route
    path="/service_offering_description"
    render={() => <Redirect to="/service_offering-description" />}
  />,
  <Route
    path="/service_vehicle"
    render={() => <Redirect to="/service-vehicle" />}
  />,
  <Route path="/service_bay" render={() => <Redirect to="/service-bay" />} />,
  <Route
    path="/technician_blurb"
    render={() => <Redirect to="/technician-blurb" />}
  />,
  <Route
    exact
    path="/calendar"
    render={(props) => (
      <Authenticated>
        <Calendar {...props} />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/schedule"
    render={() => (
      <Authenticated>
        <MuiCalendar />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/schedule/edit-availability"
    render={() => (
      <Authenticated>
        <EditAvailability />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/preview-sms"
    render={() => (
      <Authenticated>
        <PreviewSMS />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/settings"
    render={() => (
      <Authenticated>
        <Settings />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/messages"
    render={() => (
      <Authenticated>
        <Zipchat />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/business-configuration-settings"
    render={() => (
      <Authenticated>
        <BusinessConfiguration />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/activity-feed"
    render={() => (
      <Authenticated>
        <ActivityFeed />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/insights"
    render={() => (
      <Authenticated>
        <InsightPage />
      </Authenticated>
    )}
  />,
  <Route
    path="/dispatch/:date"
    render={(props) => (
      <Authenticated>
        <Dispatch {...props} />
      </Authenticated>
    )}
  />,
  <Route
    path="/dispatch"
    render={(props) => (
      <Authenticated>
        <Dispatch {...props} />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/gps-tracker"
    render={() => (
      <Authenticated>
        <GPSTracker />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/integrations"
    render={() => (
      <Authenticated>
        <Integrations />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/integrations/copy-stripe-customers-to-square"
    render={() => (
      <Authenticated>
        <StripeCustomersToSquare />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/quote-builder"
    render={() => (
      <Authenticated>
        <QuoteBuilder />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/payment-due"
    render={(props) => (
      <Authenticated>
        <PaymentDue
          {...props}
          resource="scheduled-work"
          basePath="scheduled-work"
        />
      </Authenticated>
    )}
  />,
  <Route
    exact
    path="/sales-tax-report"
    render={() => (
      <Authenticated>
        <SalesTaxReport />
      </Authenticated>
    )}
  />,
  ...ZippityPrivateRoutes,
];
